<template>
  <div class="_form">
    <b-row class="m-0">
      <b-col lg="12" class="d-flex align-items-center px-2 mt-2">
        <b-col sm="12" md="8" lg="6" class="px-xl-2 mx-auto">
          <b-card>
            <b-card-title class="mb-1 font-weight-bold text-center" title-tag="h2">
              <p>{{formName}}</p>
            </b-card-title>
            <b-card-text class="mb-2 text-center">
              Consulte aqui a situação e tratamento do formulário aberto, conforme o protocolo gerado.<br/><br/>
            </b-card-text>
            <!-- form -->
            <validation-observer ref="requestForm">
              <b-form class="mb-1 mt-2" @submit.prevent="send">
                <!-- Link -->
                <b-form-group :label="$t('protocol_query.protocol_number')" label-for="protocol_number">
                  <validation-provider
                    #default="{ errors }"
                    :name="$t('protocol_query.protocol_number')">
                    <b-form-input
                      id="protocol_number"
                      v-model="protocolNumber"
                      name="protocol_number"/>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <!-- submit buttons -->
                <div class="vx-row pt-2 print:hidden">
                  <div class="vx-col w-full">
                    <div class="flex flex-row justify-end gap-4">
                        <b-button
                          type="submit"
                          variant="primary"
                          class="waves-effect float-right"
                          :disabled="!validateForm">
                          {{$t('action.consult')}}
                        </b-button>
                        <b-button @click="clearFields" variant="outline-secondary">{{$t('action.clear')}}</b-button>
                    </div>
                  </div>
                </div>
              </b-form>
            </validation-observer>
            <!-- end form-->
            <b-card-footer>
              <form-footer/>
            </b-card-footer>
          </b-card>
        </b-col> <!-- b-coll 2-->
      </b-col> <!-- b-coll 1-->
    </b-row>
    <b-row class="m-0" v-if="list.length > 0">
      <b-col lg="12" sm="12" md="12" class="align-items-center px-2 mx-auto">
        <b-card>
            <b-card-title class="mb-1 font-weight-bold text-center" title-tag="h2">
              <p>Histórico de Tratamento do {{formName}}</p>
            </b-card-title>
            <!-- -->
            <div class="vx-row mt-1 mb-10">
              <div class="vx-col w-full">
                <b-table :items="list" :fields="fieldsDataTable"
                  :tbody-transition-props="transProps"
                  :sort-by.sync="sortBy"
                  primary-key="created_at"
                  id="table-handling"
                  striped
                  hover
                  caption-top
                  responsive="sm">
                  <template #cell(created_at)="{item: {created_at}}">
                    <span>{{ formatDate(created_at) }}</span>
                  </template>
                  <template #cell(description)="{item: {description}}">
                    <span class="break-all whitespace-pre-wrap whitespace-pre-lin simple-editor simple-content" v-html-safe="description"/>
                  </template>
                  <template #cell(forwarding_description)="{item: {forwarding_description}}">
                    <span class="break-all whitespace-pre-wrap whitespace-pre-lin simple-editor simple-content" v-html-safe="forwarding_description"/>
                  </template>
                </b-table>
              </div>
            </div>
            <!-- -->
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BRow,
  BCol,
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroupPrepend,
  BInputGroup,
  BFormCheckbox,
  BFormRadioGroup,
  BFormCheckboxGroup,
  BFormTextarea,
  BCard,
  BCardText,
  BCardTitle,
  BCardFooter,
  BImg,
  BForm,
  BButton,
  BAlert,
  VBTooltip,
  BTable,
} from 'bootstrap-vue'
import { required, email } from '@validations'
import vSelect from 'vue-select'
import Datepicker from 'educatena-vuejs-datepicker'
import { ptBR } from 'educatena-vuejs-datepicker/dist/locale'
import standard from '@/services/standard'
import FormFooter from '@/components/FormFooter.vue'


import FormProtocolQueryService from '@/services/api/FormProtocolQueryService'

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroupPrepend,
    BInputGroup,
    BFormCheckbox,
    BFormRadioGroup,
    BFormCheckboxGroup,
    BFormTextarea,
    BCard,
    BCardText,
    BCardTitle,
    BCardFooter,
    BImg,
    BForm,
    BTable,
    BButton,
    BAlert,
    ValidationProvider,
    ValidationObserver,
    vSelect,
    Datepicker,
    FormFooter
  },
  props: {
    form_type: {
      type: String,
      default: null
    },
  },
  data() {
    return {
      format: 'dd/MM/yyyy',
      ptBR,
      protocolNumber: '',
      list: [],
      fieldsDataTable: [
        { key: 'created_at', sortable: true, label: this.$t('date_hour') },
        { key: 'status_str', sortable: true, label: this.$t('status') },
        { key: 'description', label: this.$t('handling') },
        { key: 'forwarding_description', label: this.$t('forwarding_description') },
      ],
      transProps: {
        // Transition name
        name: 'flip-list'
      },
      services: {
        protocolService : null,
      }
    }
  },
  watch: {
    // Observa mudanças no parâmetro `param1`
    '$route.query.protocol_number': {
      handler(newValue) {
        if (newValue) {
          this.protocolNumber = newValue
        }
      },
      immediate: true, // Executa o watcher imediatamente ao carregar a página
    },

  },
  computed: {
    validateForm() {
      return (
        !this.isEmpty(this.protocolNumber) //&& this.protocolNumber.length > 4
      )
    },
    formName(){
      let name = ''
      switch (this.form_type) {
          case 'lgpd':
              name = this.$t('privacyFormTitle')
              break;
          case 'incident':
              name = this.$t('incidentFormTitle')
              break;
          case 'due-diligence':
              name = this.$t('dueDiligenceFormTitle')
              break;
          case 'systematic-intimidation':
              name = this.$t('systematic_intimidation.title')
              break;
          case 'reporting-channel':
              name = this.$t('reporting_channel.title')
              break;
          case 'cebas-credentialing':
              name = this.$t('portal_cebas.credentialing.title_page_public')
              break;
          default:
              name = 'unknown'
              break;
      }

      return name
    }
  },
  methods: {
    // Atualiza o parâmetro na URL
    updateQuery() {
      this.$router.push({
        path: this.$route.path,
        query: { ...this.$route.query, protocol_number: this.protocolNumber || undefined },
      });
    },
    send() {
      this.$refs.requestForm.validate().then(success => {
        if (success) {
          this.$vs.loading()
          this.clearErrors(this.$refs.requestForm)
          this.updateQuery()
          this.sendForm();
        }else{
          console.log('error!', success)
          this.errorAlertFormValidaded()
        }
      },
      error => {
        console.log('error: ', error)
      })
    },
    sendForm(){
      const params = this.getDataFields()
      this.services.protocolService.getByProtocol(this.form_type, params).then(
        response => {
          this.$vs.loading.close()
          this.list = response.data
          if(this.list.length > 0){
            this.successSend(response)
          }else{
            this.sucessSendWithDataEmpty(response)
          }
        },
        error => {
          this.$vs.loading.close()
          this.list = []
          this.notifyWarning(this.$vs,
            'Nenhum registro encontrado com o número do protocolo informado: ' + this.protocolNumber
            , 4000, 'top-center')
        }
      ).finally(() => {this.$vs.loading.close()})
    },
    successSend(data){
      this.notifySuccess(this.$vs, 'Consulta realizada com sucesso!', 3000)
      this.$vs.loading.close()
      //this.clearFields()
    },
    sucessSendWithDataEmpty(data){
      this.notifyWarning(this.$vs,
          'Nenhum registro encontrado com o número do protocolo informado!', 4000, 'top-center')
    },
    getDataFields(){
      const params = {
              protocol_number: this.protocolNumber
          }
      return params;
    },
    clearFields() {
      this.protocolNumber = '',
      this.list = []
      this.updateQuery()
      this.$nextTick( () => {this.clearErrors(this.$validator)})

    },
    errorAlertFormValidaded(){
      const firstField = this.$el.querySelector('.is-invalid')
      if(firstField){
        firstField.scrollIntoView()
      }
      this.notifyWarning(this.$vs, 'Preencha corretamente os campos do formulário!', 3000)
    },
    formatDate(timestamp) {
      const format = 'ddd, DD/MM/YYYY HH:mm'
      return this.$utils.format.dateWithFormat(timestamp, format)
    },
  },
  mounted() {
    //console.log(this.param_encrypt)
    if(this.protocolNumber){
      this.sendForm();
    }
  },
  beforeMount() {
    this.$vs.loading()
    const promisses = []

    //Services
    this.services.protocolService = FormProtocolQueryService.build(this.$vs)

    promisses.push(

    )

    Promise.all(promisses).then(() => {
      this.$vs.loading.close()
    })

  }
}
</script>

<style lang="scss">
  @import '@/assets/scss/simple-content.scss';
</style>

<style lang="scss" scoped>
  table#table-handling .flip-list-move {
    transition: transform 1s;
  }
</style>

